import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { CmeListFeatureGate } from '../Guards/CmeListFeatureGate'
import { CmeList } from '../Components/Organisms/CmeList/CmeList'

/**
 * Routed CM Environments list page.
 */
@Route(RouteID.CME)
export class CmeListPage extends Component {
    /**
     * Renders the guarded routed CM Environments page.
     *
     * @returns CM Environments list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CME}>
                <CmeListFeatureGate>
                    <LanguageContextProvider>
                        <CmeList />
                    </LanguageContextProvider>
                </CmeListFeatureGate>
            </RouteGuard>
        )
    }
}
